const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE)

export const apiClientRankings = {
	fetchMostReferralsClients: async (
		search: string | undefined,
		page: number = 1,
		perPage: number = 25,
	): Promise<IApiResponseModel<IRankingReferralModel[]>> => {
		const { data, meta } = await apiCommon<IRankingReferral[]>(`${groupPrefix}/referral-top-clients`, {
			method: 'GET',
			...createQuery({ page, perPage }, { search }),
		})

		return { data: data.map(RankingReferral), meta }
	},
}
